import EllipsisMenu from './EllipsisMenu';

export default EllipsisMenu;
